<!--<div *ngIf="this.teamContact | async as profile">-->
<mdb-card class="card-container-contact m-3" *ngIf="transporterMember">
  <mdb-card-header class="card-container-contact-header">
    <mdb-card-title>
      <h4>{{ transporterMember.firstName }} {{ transporterMember.lastName }}</h4>
      <span>{{ transporterMember.positionHeld }}</span>
    </mdb-card-title>
    <div *ngIf="getPicture()" class="image-upload-logo" [style]="getStyle()" [class.image-background]="getPicture()">
      <mdb-icon *ngIf="!getPicture()" fas icon="user" [classInside]="'text-gray'" [size]="'4x'"></mdb-icon>
    </div>
  </mdb-card-header>
  <mdb-card-body class="card-container-contact-body">
    <div class="row">
      <div class="col-auto" *ngIf="transporterMember.phone">
        <div class="d-inline-flex align-items-baseline">
          <mdb-icon fas icon="phone" [size]="'lg'"></mdb-icon>
          <p class="pl-2 lead">{{ transporterMember.phone }}</p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="transporterMember.mail">
      <div class="col-auto">
        <div class="d-inline-flex align-items-baseline">
          <mdb-icon fas icon="envelope" [size]="'lg'"></mdb-icon>
          <p class="lead">
            <a class="pl-2" [href]="'mailto:' + transporterMember.mail">{{ transporterMember.mail }} </a>
          </p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="transporterMember.description">
      <div class="col-12">
        <div class="d-inline-flex align-items-center">
          <mdb-icon fas icon="comment" [size]="'lg'"></mdb-icon>
          <p class="pl-2 pb-0 mb-0 lead">{{ transporterMember.description }}</p>
        </div>
      </div>
    </div>
  </mdb-card-body>
</mdb-card>
